import { render } from "./EventPagination.vue?vue&type=template&id=2a1cd3fe"
import script from "./EventPagination.vue?vue&type=script&lang=js"
export * from "./EventPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__